import {
  dirtyPlugin,
  FabricEditor,
  FabricEditorProvider,
  gridPlugin,
  historyPlugin,
  hotkeyPlugin,
  layerPlugin,
  selectionPlugin,
  zoomPlugin,
} from 'modules/fabric-editor';
import { layoutBlocksPlugin } from 'modules/manager/domain/layout-blocks';
import { placeholderPlugin } from 'modules/manager/domain/placeholder';
import {
  EditorCanvas,
  EditorHeader,
  EditorLayout,
  EditorLeftToolbar,
  EditorRightToolbar,
  UnsavedChangesGuard,
} from 'modules/manager/ui/components/editor';
import { useLoadBoard, useRestoreBoard } from 'modules/manager/ui/hooks';
import React, { useEffect, useState } from 'react';

const PLUGINS = [
  historyPlugin(),
  zoomPlugin(),
  selectionPlugin(),
  layerPlugin(),
  gridPlugin(),
  hotkeyPlugin(),
  dirtyPlugin(),
  placeholderPlugin(),
  layoutBlocksPlugin(),
];

const MediaManagerEditorPage: React.FC = () => {
  const { isLoaded } = useLoadBoard();
  const [editor, setEditor] = useState<FabricEditor | null>(null);
  useRestoreBoard(editor);

  useEffect(() => {
    if (!editor?.hotkeys || !editor.layers) return;
    const h = editor.hotkeys;
    const l = editor.layers;
    const bindings: Array<[string, () => void]> = [
      ['ctrl+]', () => l.bringForward()],
      ['meta+]', () => l.bringForward()],
      ['ctrl+shift+]', () => l.bringToFront()],
      ['meta+shift+]', () => l.bringToFront()],
      ['ctrl+[', () => l.sendBackwards()],
      ['meta+[', () => l.sendBackwards()],
      ['ctrl+shift+[', () => l.sendToBack()],
      ['meta+shift+[', () => l.sendToBack()],
    ];
    for (const [combo, fn] of bindings) h.bind(combo, fn);
    return () => {
      for (const [combo] of bindings) h.unbind(combo);
    };
  }, [editor]);

  return (
    <FabricEditorProvider editor={editor}>
      <EditorLayout
        header={<EditorHeader />}
        left={editor ? <EditorLeftToolbar /> : null}
        right={editor ? <EditorRightToolbar /> : null}
        canvas={<EditorCanvas plugins={PLUGINS} onReady={setEditor} />}
        isLoading={!isLoaded}
      />
      <UnsavedChangesGuard editor={editor} />
    </FabricEditorProvider>
  );
};

export default MediaManagerEditorPage;
